import {gettext} from '../../../utility/gettext.util.service';

export const RunHourStatus = {
  UPDATING: 'updating',
  SUCCESS: 'success',
  ERROR: 'error',
  NOT_REPORTED: 'not_reported'
};

export const StatusMessages = {
  UPDATING: gettext('Sending sync request.'),
  SUCCESS: gettext('Sync request sent successfully, updated run hours will be displayed once it is communicated.'),
  ERROR: gettext('An error occurred while trying to update the run hours.'),
  GET_RUNHOURS_ERROR: gettext('An error occurred while retrieving the run hours.'),
  NOT_REPORTED: gettext('Run hours has not been communicated yet.'),
  NOT_REPORTED_M5: gettext('Sync run hours will be available once it is communicated.'),
  NOT_REPORTED_Not_M5: gettext('The run hours will be set to the new value once it is communicated.')
};
